export default __webpack_public_path__ + "locales/lo-LA/People.json?hash=2fc831b9f01ab77b3a5da9096ef25476";